import { Grid, Stack } from '@mui/material';

import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { IControlQualityCheck } from 'common/api/type-def';
import {
	AI_SIMULATION_TYPES,
	AI_TYPE,
} from 'common/constants/AISimulationConstants';
import { RootState } from 'common/store/AppStore';
import {
	setSimulationCommonSaveDrawer,
	setSimulationCommonShareDrawer,
} from 'common/store/reducer/commonReducer';
import {
	setControlQuality,
	setRegulationText,
	setResetCtrlDescription,
} from 'common/store/reducer/simulationReducer';

import { IAIModelDetails } from '../api/type-def';
import AIModelSave from '../Components/AIModelSave/AIModelSave';
import AIShare from '../Components/AIShare/AIShare';
import StepHeader from '../Components/StepHeader/StepHeader';
import { aiModelPDFDownload } from '../ObligationAndControl/ObligationAndControlModules';

import ControlQualityInput from './ControlQuality/ControlQualityInput';
import ControlQualityOutput from './ControlQuality/ControlQualityOutput';

const ControlQualityWrapper = () => {
	const dispatch = useDispatch();

	const { CONTROL_QUALITY_GRAMMAR_CHECK } = AI_SIMULATION_TYPES;
	const { MODEL } = AI_TYPE;
	const controlQuality = useSelector(
		(state: RootState) => state.simulationArena.controlQuality,
	);

	const selectedAIModel = useSelector(
		(state: RootState) => state.simulationArena.selectedAIModel,
	);
	const handleControlSave = () => {
		dispatch(setSimulationCommonSaveDrawer(true));
	};

	const handleControlShare = () => {
		dispatch(setSimulationCommonShareDrawer(true));
	};
	const [isUpdateControlLoading, setIsUpdateControlLoading] = useState(false);

	const handleLoader = (isLoading: boolean) => {
		setIsUpdateControlLoading(isLoading);
		setResetCtrlDescription(isLoading);
	};

	useEffect(() => {
		if (selectedAIModel.input && selectedAIModel.output) {
			let output: IControlQualityCheck;
			try {
				output = JSON.parse(selectedAIModel.output);
				dispatch(setControlQuality(output));
				dispatch(setRegulationText(selectedAIModel.input as string));
			} catch {
				output = {} as IControlQualityCheck;
			}
		}
	}, [selectedAIModel]);

	const aiModelData: IAIModelDetails = {
		...(selectedAIModel?.id ? { id: selectedAIModel.id } : {}),
		name: selectedAIModel?.name || '',
		input: controlQuality.control_content,
		output: JSON.stringify(controlQuality),
		workflowStep: CONTROL_QUALITY_GRAMMAR_CHECK,
		type: MODEL,
	};

	const handleControlDownload = () => {
		aiModelPDFDownload(
			selectedAIModel.name,
			CONTROL_QUALITY_GRAMMAR_CHECK,
			CONTROL_QUALITY_GRAMMAR_CHECK,
			{
				inputTitle: 'Language Quality Check Content',
				inputValue: controlQuality.control_content,
			},
			{
				outputTitle: 'Updated Control Description',
				outputValue: controlQuality.updatedDescription,
			},
			undefined,
			{
				fiveWResponse: JSON.stringify(controlQuality?.five_ws),
				grammarScore: JSON.stringify(controlQuality?.grammarScore),
				controlMapping: JSON.stringify(controlQuality?.controlMapping),
				additionalInfo: controlQuality?.additional_info,
			},
		);
	};

	return (
		<>
			<Stack>
				<StepHeader title={CONTROL_QUALITY_GRAMMAR_CHECK} />
				<Grid container spacing={1}>
					<Grid item sm={4} md={4}>
						<ControlQualityInput
							isUpdateControlLoading={isUpdateControlLoading}
							handleSave={handleControlSave}
							handleShare={handleControlShare}
							handleDownload={handleControlDownload}
							handleLoader={handleLoader}
						/>
					</Grid>
					{controlQuality?.updatedDescription && (
						<Grid item sm={8} md={8}>
							<ControlQualityOutput
								isUpdateControlLoading={isUpdateControlLoading}
							/>
						</Grid>
					)}
				</Grid>
			</Stack>

			<AIModelSave aiModeldata={aiModelData} isSaveBtnVisible={false} />
			<AIShare aiSharedData={aiModelData} type={MODEL} />
		</>
	);
};

export default ControlQualityWrapper;
